import { createReducer, on } from '@ngrx/store';
import { ConfigEditorDetailVariant, StreamingConfig } from '../../domain/config';
import * as Actions from './general-streaming-config-editor-screen.actions';

export const featureKey = 'cxbConfigStreamingEditorScreen';

export interface FeatureState {
  configs: StreamingConfig[];
  config: StreamingConfig;
  variant: ConfigEditorDetailVariant;
  loading: boolean;
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  configs: undefined,
  config: undefined,
  variant: undefined,
  loading: false,
};

export const reducer = createReducer(
  initialState,
  on(Actions.loadCxbStreamingConfigEntries, (state): FeatureState => ({ ...state, configs: undefined, loading: true })),
  on(
    Actions.loadCxbStreamingConfigEntriesSuccess,
    (state, action): FeatureState => ({ ...state, configs: action.configs, loading: false })
  ),
  on(Actions.loadCxbStreamingConfigEntriesFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.loadCxbStreamingConfigEntry, (state): FeatureState => ({ ...state, config: undefined, loading: true })),
  on(
    Actions.loadCxbStreamingConfigEntrySuccess,
    (state, action): FeatureState => ({ ...state, config: action.config, variant: action.variant, loading: false })
  ),
  on(Actions.loadCxbStreamingConfigEntryFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.leaveConfigEditorDetailScreen, (state): FeatureState => ({ ...state, config: undefined, variant: undefined })),

  on(Actions.createCxbStreamingConfigEntry, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.createCxbStreamingConfigEntrySuccess, (state): FeatureState => ({ ...state, loading: false })),
  on(Actions.createCxbStreamingConfigEntryFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.updateCxbStreamingConfigEntry, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.updateCxbStreamingConfigEntrySuccess, (state): FeatureState => ({ ...state, loading: false })),
  on(Actions.updateCxbStreamingConfigEntryFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.deleteCxbStreamingConfigEntry, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.deleteCxbStreamingConfigEntrySuccess, (state): FeatureState => ({ ...state, loading: false })),
  on(Actions.deleteCxbStreamingConfigEntryFail, (state): FeatureState => ({ ...state, loading: false }))
);
